import React from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { netScotlandTheme } from './theme/netScotlandTheme';
import { EnvironmentBanner } from './layout/EnvironmentBanner';

/**
 * Plan 13: wrap the whole app (public routes + react-admin tree alike)
 * in `netScotlandTheme`. The public PublicLayout still mounts its own
 * inner ThemeProvider with the same theme so the public surface keeps
 * its react-admin isolation guarantee (Pitfall 5) — applying the theme
 * at the root just covers any non-PublicLayout/non-Admin context.
 *
 * NOTE: atomic-crm's entry file is `src/index.tsx` (Create-React-App
 * convention preserved through the Vite migration). The plan body
 * referenced `src/main.tsx`; this file is the same entry point.
 */
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={netScotlandTheme}>
            <CssBaseline />
            {/* Mounted at the ROOT, above <App />, so it shows on the login page
                and the public calendar as well as the signed-in app. A banner
                that only appears after signing in is missing exactly when
                someone is deciding which site they are on. Renders nothing
                unless VITE_ENV_LABEL is set, so production is unchanged. */}
            <EnvironmentBanner />
            <App />
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
